export default {
  title: 'Cadastro de usuários',
  labels: {
    birthday: 'Nascimento',
    bank: 'Banco',
    capital: 'Capital',
    cnh: 'CNH',
    contacts: 'Contatos',
    cpf: 'CPF',
    extract: 'Extrato',
    gender: 'Sexo',
    id: 'ID',
    name: 'Nome',
    new: 'Cadastrar Usuário',
    rg: 'RG'
  },
  options: {
    gender: {
      M: 'Masculino',
      F: 'Feminino'
    }
  }
}
